@if (
  {
    trackersMap: trackersMap$ | async,
    metricsDisplay: metricsDisplay$ | async,
    project: project$ | async,
    taskTemplates: taskTemplates$ | async
  };
  as state
) {
  @if (state.project) {
    <div cdkDropListGroup class="main-container">
      <div class="left-container">
        <div class="header-rows">
          <div class="header-row-back">
            <oph-back-button (buttonClick)="onBackClick()"></oph-back-button>
          </div>
          <div class="header-row-project">
            <div class="project-color" [style.background-color]="state.project.color || '#E5E3DC'"></div>
            <span class="project-label">{{ state.project.label }}</span>
            <oph-new-button
              class="new-step-button"
              (buttonClick)="onOpenStepDialog(null, null)"
              [buttonStyle]="{width: '153px', height: '34px', borderRadius: '6px', background: 'var(--light)'}"
              >New Step</oph-new-button
            >
          </div>
        </div>
        <!-- --------------STEPS---------------- -->
        <div class="steps-wrapper">
          @for (step of state.project.steps; track step; let stepIndex = $index) {
            <div class="step-container" [class.inactive-step]="step.status !== 'active'">
              @if (state.trackersMap) {
                <div
                  [class.show]="step.previousStepRequired"
                  class="connector-container"
                  [matTooltip]="
                    (state.project.steps[stepIndex - 1] | isTrackerComplete: state.trackersMap : 'completionTracker')
                      ? null
                      : 'The preceding step has no completion rule.'
                  "
                  matTooltipPosition="right"
                >
                  <img src="assets/img/icons/projects/connector.svg" />
                  @if (
                    !(state.project.steps[stepIndex - 1] | isTrackerComplete: state.trackersMap : 'completionTracker')
                  ) {
                    <img src="assets/img/icons/projects/alert-triangle.svg" class="alert-triangle" />
                  }
                </div>
              }

              <div
                class="drop-container"
                cdkDropList
                [cdkDropListData]="{tasks: step.tasks, isTemplate: false, stepIndex}"
                (cdkDropListDropped)="taskDrop($event)"
              >
                <div class="step-header">
                  @if (step.status === 'complete') {
                    <oph-icon name="check-green-background" [size]="30"></oph-icon>
                  } @else {
                    <div class="uncomplete-step-count">{{ stepIndex + 1 }}</div>
                  }
                  {{ step.name }}
                  <div class="step-header-right-container">
                    <oph-chip-button (buttonClick)="onOpenAlertsDialog(undefined, step._id)">Alert</oph-chip-button>
                    <oph-chip-button (buttonClick)="onCreateTaskForProject(stepIndex)">Task</oph-chip-button>
                    <button class="edit-step-button" (click)="onStepEdit(step, stepIndex)">
                      <mat-icon svgIcon="pencil-outline"></mat-icon>
                    </button>
                  </div>
                </div>

                @if (state.metricsDisplay && state.trackersMap && step.activationTracker) {
                  @if (state.metricsDisplay?.[stepIndex]?.activation?.name && stepIndex !== 0) {
                    <div
                      class="tracker-display-container activation"
                      [class.task-list-empty-margin]="!step.tasks.length"
                    >
                      <oph-icon name="start-green" [size]="19" class="start-green-icon"></oph-icon>
                      <span class="main-span">
                        Activate when
                        <span class="bold-metric">{{ state.metricsDisplay[stepIndex]?.activation?.name }}</span>
                        {{ step.activationTracker.operator | operatorDisplay }}
                        <span class="bold-metric">{{ state.metricsDisplay[stepIndex]?.activation?.value }}</span>
                      </span>
                    </div>
                  }
                }

                <div class="task-list">
                  @for (task of step.tasks; track task; let i = $index) {
                    <projects-edit-task
                      #taskContainer
                      [task]="task"
                      [requirementsMap]="requirementsMap$ | async"
                      [locationsMap]="locationsMap$ | async"
                      [loading]="(loadingStepIndex$ | async) === stepIndex && (loadingTaskIndex$ | async) === i"
                      (click)="onEditProjectTask(stepIndex, step._id, i)"
                    ></projects-edit-task>
                  }
                </div>
                @if ({loadingAlertIndex: loadingAlertIndex$ | async}; as state) {
                  <div class="alert-list">
                    @for (alert of step.alerts || []; track alert; let alertIndex = $index) {
                      <button class="alert-button" (click)="onOpenAlertsDialog(alert, step._id)">
                        <oph-icon [name]="'alert-icons/' + alert.icon" [size]="44"></oph-icon>
                        <div class="alert-text-container">
                          <span class="alert-text">{{ alert.name }}</span>
                          <span class="alert-subtext">{{ alert.alertText }}</span>
                        </div>
                        <button
                          class="bell-icon-button"
                          (click)="onToggleAlert($event, alert, alertIndex, step._id)"
                          [disabled]="state.loadingAlertIndex && state.loadingAlertIndex.stepId === step._id"
                        >
                          @if (
                            state.loadingAlertIndex &&
                            state.loadingAlertIndex.stepId === step._id &&
                            state.loadingAlertIndex.index === alertIndex
                          ) {
                            <div class="oph-orange-spinner">
                              <mat-spinner diameter="19"></mat-spinner>
                            </div>
                          } @else {
                            <oph-icon [name]="alert.active ? 'bell-orange' : 'bell-inactive'" [size]="18"></oph-icon>
                          }
                        </button>
                      </button>
                    }
                  </div>
                }
              </div>
              <oph-add-button (buttonClick)="onCreateTaskForProject(stepIndex)">New task</oph-add-button>
              @if (state.metricsDisplay && state.trackersMap) {
                @if (state.metricsDisplay?.[stepIndex]?.completion?.name) {
                  <div class="tracker-display-container">
                    <oph-icon name="check-square-green" [size]="19"></oph-icon>
                    <span class="main-span"
                      >Complete when
                      <span class="bold-metric">{{ state.metricsDisplay[stepIndex]?.completion?.name }}</span>
                      {{ step.completionTracker.operator | operatorDisplay }}
                      <span class="bold-metric">{{ state.metricsDisplay[stepIndex]?.completion?.value }}</span>
                    </span>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>

      <div class="tabs-container">
        <oph-button-group
          [options]="tabOptions"
          [selectedOptionName]="selectedTab$ | async"
          (optionClick)="onTabChange($event)"
        ></oph-button-group>
        <oph-search-input
          [control]="search"
          [inputStyle]="{height: '42px'}"
          placeholder="Search Task Templates"
        ></oph-search-input>
        <oph-new-button (buttonClick)="openTaskTemplateDialog()">New Task Template</oph-new-button>

        <!-- --------------TASK TEMPLATE LIST---------------- -->
        <div
          cdkDropList
          [cdkDropListData]="{taskTemplates: state.taskTemplates, isTemplate: true}"
          cdkDropListSortingDisabled
          class="template-list"
        >
          @for (taskTemplate of state.taskTemplates; track taskTemplate._id) {
            <div class="task-item">
              <projects-edit-task
                [template]="true"
                [task]="$any(taskTemplate)"
                [requirementsMap]="requirementsMap$ | async"
                [locationsMap]="locationsMap$ | async"
                (click)="openTaskTemplateDialog(taskTemplate)"
              ></projects-edit-task>
            </div>
          }
        </div>
      </div>
    </div>
  }
}
